import React from 'react';
import { Button, Paper, Typography } from '@mui/material';

export function SpotlightOverlay(props: {
  open: boolean;
  targetEl?: HTMLElement | null;
  targetRef?: React.RefObject<HTMLElement | null> | undefined;
  title: string;
  description: string;
  onSkip?: () => void;
  elevateTarget?: boolean;
}) {
  const { open, title, description, onSkip } = props;
  if (!open) return null;

  return (
    <Paper
      elevation={10}
      sx={{
        position: 'fixed',
        left: { xs: 12, sm: 24 },
        right: { xs: 12, sm: 'auto' },
        bottom: { xs: 12, sm: 24 },
        maxWidth: { xs: 'unset', sm: 420 },
        p: 2,
        borderRadius: 2,
        // Abaixo do Modal (1300): senão o cartão pode ficar por cima do Dialog e bloquear digitação/toques no formulário.
        zIndex: (theme) => theme.zIndex.modal - 10,
        maxHeight: '42vh',
        overflowY: 'auto',
      }}
    >
      <Typography fontWeight={800} sx={{ mb: 0.5 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, lineHeight: 1.6 }}>
        {description}
      </Typography>
      {onSkip ? (
        <Button variant="text" onClick={onSkip} sx={{ textTransform: 'none' }}>
          Pular onboarding
        </Button>
      ) : null}
    </Paper>
  );
}

